function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomPoolViewOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.748 21.69a3.897 3.897 0 01-2.774-1.15c-.79-.79-2.166-.79-2.957 0v-2.155c.464-.19.964-.29 1.479-.29 1.048 0 2.032.409 2.774 1.15.79.791 2.167.79 2.957 0A3.897 3.897 0 0116 18.095c1.048 0 2.033.409 2.774 1.15.79.79 2.167.79 2.956 0a3.897 3.897 0 012.774-1.15c.516 0 1.015.1 1.479.29v2.155c-.79-.79-2.167-.79-2.957 0a3.894 3.894 0 01-2.773 1.15 3.894 3.894 0 01-2.774-1.15c-.79-.79-2.167-.79-2.957 0a3.896 3.896 0 01-2.774 1.15zm9.982 1.865a3.897 3.897 0 012.774-1.15c.516 0 1.015.101 1.479.29v2.155c-.79-.79-2.167-.79-2.957 0A3.896 3.896 0 0120.252 26a3.894 3.894 0 01-2.773-1.15c-.79-.79-2.167-.79-2.957 0A3.897 3.897 0 0111.748 26a3.895 3.895 0 01-2.774-1.15c-.79-.79-2.166-.79-2.957 0v-2.155c.464-.189.964-.29 1.479-.29 1.048 0 2.032.409 2.774 1.15.79.791 2.167.79 2.957 0A3.897 3.897 0 0116 22.405c1.049 0 2.033.409 2.774 1.15.79.79 2.167.79 2.956 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.072 17.012V8.481c0-.485.189-.941.532-1.285.687-.687 1.884-.687 2.57 0m-6.638 0c-.687-.687-1.884-.687-2.57 0-.344.343-.533.8-.533 1.285v8.531",
    stroke: props.color,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.964 10.743h5.464M12.964 14.25h5.464",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "square"
  }));
}

export default SvgIconRoomPoolViewOutline;